// Shared helpers for the single, loan-level "Income Documentation Type" value
// (currentLoanSlice.incomeDocumentationType). Values are the INCOME_VERIFICATION_TYPES
// enum from utils/quickPricerConstants.js.

export const isDSCRstyle = (incomeDocumentationType) =>
	incomeDocumentationType === "InvestorDscr" ||
	incomeDocumentationType === "InvestorNoRatio";

export const docFamily = (incomeDocumentationType) => {
	if (!incomeDocumentationType) return null;
	if (isDSCRstyle(incomeDocumentationType)) return "DSCR";
	if (incomeDocumentationType.indexOf("BankStmt") >= 0) return "Bank Statement";
	if (incomeDocumentationType === "AssetRelated") return "Asset Qual";
	if (incomeDocumentationType.indexOf("PL") === 0) return "P&L";
	if (incomeDocumentationType.indexOf("1099") >= 0) return "1099";
	return "Full Doc";
};
